var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 14.1667L10.5 13.3333C10.5 12.9167 9.66667 12.0833 9.66667 11.6667C7.44167 11.6667 3 12.7833 3 15V16.6667H10.5L9.25 14.1667ZM9.66667 10C11.5083 10 13 8.50834 13 6.66667C13 4.825 11.5083 3.33334 9.66667 3.33334C7.825 3.33334 6.33333 4.825 6.33333 6.66667C6.33333 8.50834 7.825 10 9.66667 10Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4394 11.443L16.5454 11.3369L16.4394 11.2308L15.9358 10.7273L15.8297 10.6212L15.7237 10.7273L13.8333 12.6176L11.943 10.7273L11.8369 10.6212L11.7308 10.7273L11.2272 11.2308L11.1212 11.3369L11.2272 11.443L13.1176 13.3333L11.2272 15.2237L11.1212 15.3298L11.2272 15.4358L11.7308 15.9394L11.8369 16.0455L11.943 15.9394L13.8333 14.049L15.7237 15.9394L15.8297 16.0455L15.9358 15.9394L16.4394 15.4358L16.5454 15.3298L16.4394 15.2237L14.549 13.3333L16.4394 11.443Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.7ca7d4eebeff3767a7fb428b5521be5b.svg";
export { ForwardRef as ReactComponent };